var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHand = function SvgHand(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.75V4.75C13.75 3.64543 14.6454 2.75 15.75 2.75C16.8546 2.75 17.75 3.64543 17.75 4.75V8.75M17.75 9.25V12.0792C17.75 16.0395 14.5395 19.25 10.5792 19.25C7.91687 19.25 5.47366 17.775 4.23368 15.419L1.25 9.75L2.00061 8.81174C2.69063 7.94921 3.94921 7.80937 4.81174 8.49939L5.75 9.25V8.25M5.75 8V3.75C5.75 2.64543 6.64543 1.75 7.75 1.75C8.85457 1.75 9.75 2.64543 9.75 3.75V8.25M9.75 5.75V2.75C9.75 1.64543 10.6454 0.75 11.75 0.75C12.8546 0.75 13.75 1.64543 13.75 2.75V9",
    stroke: "#F8F8F8",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHand;